export default {
  addToLibrarySuccess: 'Track added to library:',
  removeFromLibrarySuccess: 'Track removed from library:',
  goToLibrary: 'Go to Library',
  actions: {
    downloadPDF: 'PDF License',
    deleteSong: 'Remove from library',
    addToLibrary: 'Add to Library',
  },
  songFormats: {
    mp3: 'MP3',
    wav: 'WAV',
    stems: 'Stems',
    samplePack: 'Sample Pack',
  },
  newSong: 'New',
  placeholder: {
    main: 'We couldn’t find any tracks matching those filters.',
    emptyList: 'No tracks added to library yet.',
  },
  subtitle: {
    mp3: 'Good sound, small size.',
    wav: 'Premium sound quality.',
    stems: 'Individual instrument tracks + full mixed song (WAV).',
    samplePack: 'Loops from this song: drums, melodies, FX, and more (WAV).',
    pdf: 'Your proof of usage rights made easy.',
  },
  upgrade: 'UPGRADE',
  loadMore: 'Load More',
};
